import { CommonSchemaIds } from '../../schemas/common.const.js';
export const dictionary = {
    schema: {
        [CommonSchemaIds.VISIBLE]: {
            title: 'Visibility',
            description: 'Show or hide content.',
            abbr: 'Visibility',
            cti: 'Indicate whether to hide the content or not.'
        },
        [CommonSchemaIds.INTERVAL]: {
            title: 'Interval',
            description: 'Interval of the distribution.',
            abbr: 'Interval',
            cti: 'Provide the requested count interval.'
        }
    }
};
